/**
 * SBM – Product page buy flow (see snippets/sbm-pdp-buy-flow.liquid)
 *
 * - No size pre-selected on load; "Select Size & Fit" shows until every size option is picked.
 * - Co-ord sets (Size-TOP + Size - Bottom): the theme only reloads the variant once all sizes are picked.
 * - After picking: Add to Cart + Buy Now side by side. Sold-out size keeps the theme's Notify Me.
 * - Wishlist Hero heart + Share on the top-right of the product image.
 *
 * The theme re-renders the product area from the server on every variant change, so everything here
 * is idempotent and re-applied by a MutationObserver.
 */
(function () {
  if (window.__sbmPdpLoaded) return;
  window.__sbmPdpLoaded = true;

  var configEl = document.getElementById('sbm-pdp-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var root = document.documentElement;
  var formId = config.formId;
  var required = config.requiredPositions || [];
  var labels = config.labels || {};
  var picked = {}; // position -> radio value (option value id)
  var allPicked = !config.flowEnabled || root.classList.contains('sbm-size-chosen');

  var SHARE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
    '<path d="M14 5l6 6-6 6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M20 11H11a7 7 0 0 0-7 7v1" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  /* ------------------------------------------------------------------ helpers */

  function sectionEl() {
    return document.getElementById('shopify-section-' + config.sectionId) || document.body;
  }

  function mainForm() {
    return document.getElementById(formId);
  }

  function radiosFor(position) {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        'input.block-swatch__radio[form="' + formId + '"][data-option-position="' + position + '"]'
      )
    );
  }

  function groupFor(position) {
    var radios = radiosFor(position);
    return radios.length ? radios[0].closest('.product-form__option-selector') : null;
  }

  function labelTextFor(radio) {
    var label = document.querySelector('label[for="' + radio.id + '"]');
    return label ? label.textContent.trim() : '';
  }

  function firstUnpicked() {
    for (var i = 0; i < required.length; i++) {
      if (!picked[required[i]]) return required[i];
    }
    return null;
  }

  function setAllPicked() {
    allPicked = true;
    root.classList.remove('sbm-no-size');
    root.classList.add('sbm-size-chosen');
    document.querySelectorAll('.sbm-unpicked').forEach(function (g) {
      g.classList.remove('sbm-unpicked', 'sbm-size-error');
    });
    document.querySelectorAll('.sbm-size-msg').forEach(function (m) {
      m.remove();
    });
  }

  function toast(text) {
    var t = document.createElement('div');
    t.className = 'sbm-toast';
    t.textContent = text;
    document.body.appendChild(t);
    setTimeout(function () {
      t.remove();
    }, 1800);
  }

  /* ------------------------------------------------------- size selection state */

  function syncSizeState() {
    if (allPicked) return;
    root.classList.add('sbm-no-size');

    required.forEach(function (position) {
      var radios = radiosFor(position);
      if (!radios.length) return;
      var group = radios[0].closest('.product-form__option-selector');
      var valueEl = group && group.querySelector('.product-form__option-value');

      if (picked[position]) {
        radios.forEach(function (r) {
          var shouldCheck = r.value === picked[position];
          if (r.checked !== shouldCheck) r.checked = shouldCheck;
        });
        if (group) group.classList.remove('sbm-unpicked');
      } else {
        radios.forEach(function (r) {
          if (r.checked) r.checked = false;
          if (r.hasAttribute('checked')) r.removeAttribute('checked');
        });
        if (valueEl && valueEl.textContent !== '') valueEl.textContent = '';
        if (group && !group.classList.contains('sbm-unpicked')) group.classList.add('sbm-unpicked');
      }
    });
  }

  function promptSize() {
    var position = firstUnpicked() || required[0];
    var group = groupFor(position);
    if (!group) return;

    var top = group.getBoundingClientRect().top + window.pageYOffset - 140;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });

    if (!group.querySelector('.sbm-size-msg')) {
      var msg = document.createElement('p');
      msg.className = 'sbm-size-msg';
      msg.textContent = labels.pleaseSelect || 'Please select a size';
      var list = group.querySelector('.block-swatch-list');
      if (list && list.parentNode) list.parentNode.insertBefore(msg, list.nextSibling);
      else group.appendChild(msg);
    }

    group.classList.remove('sbm-size-error');
    void group.offsetWidth; // restart the shake animation
    group.classList.add('sbm-size-error');
    setTimeout(function () {
      group.classList.remove('sbm-size-error');
    }, 600);
  }

  // Runs before the theme's own listener (capture on document).
  document.addEventListener(
    'change',
    function (event) {
      if (allPicked) return;
      var input = event.target;
      if (!input || !input.matches || !input.matches('input.block-swatch__radio')) return;
      if (input.getAttribute('form') !== formId) return;

      var position = parseInt(input.getAttribute('data-option-position'), 10);
      if (required.indexOf(position) === -1) return;

      picked[position] = input.value;

      var group = input.closest('.product-form__option-selector');
      if (group) {
        group.classList.remove('sbm-unpicked', 'sbm-size-error');
        var msg = group.querySelector('.sbm-size-msg');
        if (msg) msg.remove();
        var valueEl = group.querySelector('.product-form__option-value');
        if (valueEl) valueEl.textContent = labelTextFor(input);
      }

      if (firstUnpicked() === null) {
        // Every size chosen: let the theme load the variant as usual.
        setAllPicked();
        return;
      }

      // Another size option (e.g. bottom size of a co-ord) is still empty: don't let the theme
      // auto-pick it. Keep the choice visually and wait.
      event.stopImmediatePropagation();
    },
    true
  );

  // Block any add to cart (main button, desktop sticky bar) until a size is picked.
  document.addEventListener(
    'click',
    function (event) {
      if (allPicked) return;
      var btn = event.target.closest && event.target.closest('[data-product-add-to-cart-button]');
      if (!btn) return;
      var owner = btn.getAttribute('form') || (btn.form && btn.form.id);
      if (owner !== formId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      promptSize();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (allPicked) return;
      if (!event.target || event.target.id !== formId) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      promptSize();
    },
    true
  );

  /* -------------------------------------------------------------- buttons */

  function ensureSelectSizeButton() {
    if (!config.flowEnabled) return;
    var form = mainForm();
    if (!form || form.querySelector('.sbm-select-size')) return;
    var payment = form.querySelector('product-payment-container');
    if (!payment) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sbm-select-size';
    btn.textContent = labels.selectSize || 'Select Size & Fit';
    form.insertBefore(btn, payment);
  }

  function ensureBuyNowButton() {
    if (!config.showBuyNow) return;
    var form = mainForm();
    var payment = form && form.querySelector('product-payment-container');
    if (!payment || payment.querySelector('.sbm-buy-now')) return;
    var atc = payment.querySelector('#AddToCart');
    if (!atc) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sbm-buy-now';
    btn.innerHTML =
      '<span class="sbm-buy-now__text"></span><div style="display:none" class="addloadr"><div class="cir-loader">Loading..</div></div>';
    btn.querySelector('.sbm-buy-now__text').textContent = labels.buyNow || 'Buy it now';
    atc.parentNode.insertBefore(btn, atc.nextSibling);
    payment.classList.add('sbm-has-buy-now');
  }

  function currentVariantId() {
    var variants = config.variants || [];
    var chosen = {};
    document
      .querySelectorAll('input.block-swatch__radio[form="' + formId + '"]:checked')
      .forEach(function (r) {
        chosen[parseInt(r.getAttribute('data-option-position'), 10)] = labelTextFor(r);
      });

    var match = variants.filter(function (v) {
      return Object.keys(chosen).every(function (pos) {
        return v.options[pos - 1] === chosen[pos];
      });
    })[0];

    if (match) return match.id;
    var form = mainForm();
    var idInput = form && form.querySelector('[name="id"]');
    return idInput ? parseInt(idInput.value, 10) : null;
  }

  function currentQuantity() {
    var q = document.querySelector('input[name="quantity"][form="' + formId + '"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function goToCheckout(btn) {
    // GoKwik checkout when available, otherwise Shopify checkout.
    if (typeof window.onCheckoutClick === 'function') {
      try {
        window.onCheckoutClick(btn);
        return;
      } catch (e) {
        /* fall through */
      }
    }
    window.location.href = '/checkout';
  }

  function buyNow(btn) {
    if (!allPicked) {
      promptSize();
      return;
    }
    var variantId = currentVariantId();
    if (!variantId) return;

    btn.classList.add('is-loading');
    var routesRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    fetch(routesRoot + "cart/add.js", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: currentQuantity() }] }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        goToCheckout(btn);
        setTimeout(function () {
          btn.classList.remove('is-loading');
        }, 2500);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        toast((err && (err.description || err.message)) || 'Could not add to cart');
      });
  }

  /* ----------------------------------------------- wishlist + share on image */

  var galleries = [
    { slot: 'mobile', selector: '.product-mobile-media' },
    { slot: 'desktop', selector: '.product-media-desktop' },
  ];

  function ensureMediaActions() {
    var scope = sectionEl();
    var anyReady = false;

    galleries.forEach(function (g) {
      var gallery = scope.querySelector(g.selector);
      if (!gallery) return;

      var actions = gallery.querySelector(':scope > .sbm-media-actions');
      if (!actions) {
        actions = document.createElement('div');
        actions.className = 'sbm-media-actions';
        actions.innerHTML = '<div class="sbm-media-actions__btn sbm-media-actions__wish"></div>';
        gallery.appendChild(actions);
      }

      var wishSlot = actions.querySelector('.sbm-media-actions__wish');
      var placed = wishSlot.querySelector('[data-sbm-wlh]');
      var fresh = scope.querySelector('.sbm-wlh-holder [data-sbm-wlh="' + g.slot + '"]');

      if (!placed && fresh) {
        wishSlot.appendChild(fresh);
        placed = fresh;
      } else if (placed && fresh) {
        // A re-render produced a new placeholder but our heart is still on the image: drop the duplicate.
        fresh.remove();
      }

      var ready = !!(placed && placed.children.length);
      if (ready !== wishSlot.classList.contains('is-ready')) wishSlot.classList.toggle('is-ready', ready);
      if (ready) anyReady = true;
    });

    if (anyReady !== root.classList.contains('sbm-wlh-ok')) root.classList.toggle('sbm-wlh-ok', anyReady);
  }

  function share() {
    var data = { title: config.title, url: config.url };
    if (navigator.share) {
      navigator.share(data).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(config.url).then(function () {
        toast(labels.linkCopied || 'Link copied');
      });
    }
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;

    if (t.closest('.sbm-select-size')) {
      event.preventDefault();
      promptSize();
      return;
    }
    var buy = t.closest('.sbm-buy-now');
    if (buy) {
      event.preventDefault();
      buyNow(buy);
      return;
    }
    if (t.closest('.sbm-media-actions__share')) {
      event.preventDefault();
      share();
    }
  });

  /* ---------------------------------------------------------------- apply */

  function apply() {
    syncSizeState();
    ensureSelectSizeButton();
    ensureBuyNowButton();
    ensureMediaActions();
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  apply();

  new MutationObserver(scheduleApply).observe(sectionEl(), { childList: true, subtree: true });

  // Wishlist Hero renders its heart asynchronously; keep checking for a few seconds.
  var checks = 0;
  var timer = setInterval(function () {
    ensureMediaActions();
    if (++checks > 20 || root.classList.contains('sbm-wlh-ok')) clearInterval(timer);
  }, 500);

  // Back/forward cache can restore the old radio state.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) apply();
  });
})();
